import React from 'react'
import { useValue } from '@morningtrain/react-resources'
import LineChartWidget from 'widgets/charts/LineChartWidget'
import GoodsUsageChartTooltip from 'widgets/charts/GoodsUsageChartTooltip'

export default function GoodsUsageChartLoader () {
  const entries = useValue('entries', [])

  const lines = [
    {
      dataKey: 'kitchen_percentage',
      stroke: '#e15b5b'
    },
    {
      dataKey: 'bar_percentage',
      stroke: '#69b3e4'
    },
    {
      dataKey: 'total_percentage',
      stroke: '#616DE1'
    },
  ]

  return (
    <LineChartWidget
      data={entries}
      lines={lines}
      tooltipContent={<GoodsUsageChartTooltip/>}
      xTick={{
        type: 'time',
        mode: 'monthly',
      }}
      yTick={{
        type: 'percentage',
      }}
      xDataKey='timestamp'
    />
  )
}
